'use client';

import { Locale } from '@/i18n';
import { Link, usePathname } from '@/i18n/routing';
import { IconSize } from '@diamond-block/ui';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { TbCaretDown, TbLanguage } from 'react-icons/tb';

interface LocaleItem {
  locale: Locale;
  long: string;
}

export const LanguageSelector = () => {
  const locale = useLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const LANGUAGES: LocaleItem[] = [
    { locale: 'en', long: 'English' },
    { locale: 'de', long: 'Deutsch' },
  ];
  return (
    <div key="languages" className="dropdown dropdown-end dropdown-hover">
      <div
        tabIndex={0}
        role="button"
        className="btn btn-ghost max-md:btn-square"
      >
        <TbLanguage size={IconSize.btn} aria-label="Language/Sprache" />
        <span className="max-md:hidden">{locale.toUpperCase() || 'EN'}</span>
        <TbCaretDown
          size={IconSize.btnCaret}
          aria-hidden
          className="max-md:hidden"
        />
      </div>
      <ul
        tabIndex={0}
        className="menu dropdown-content rounded-box bg-base-100 dark:bg-base-200 text-base-content z-2 min-w-48 p-2 shadow-sm"
      >
        {LANGUAGES.map((item) => (
          <li key={item.locale}>
            <Link
              href={`${pathname}?${searchParams.toString()}`}
              locale={item.locale}
              className={`${item.locale === locale ? 'menu-active' : ''}`}
            >
              {item.long}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
